__turbopack_context__.v({
  "header": "toolip-module__b0rFsW__header",
  "table": "toolip-module__b0rFsW__table",
  "title": "toolip-module__b0rFsW__title",
  "wrapper": "toolip-module__b0rFsW__wrapper",
});
